export const reviews = ()=> {
    let reviewsTriggerDesktop;
    let reviewsTriggerMobile;

    const sections = document.querySelectorAll('.reviews')

    sections?.forEach(section=> {
        const itemsDesktop = section.querySelectorAll('.reviews__item')
        const itemsMobile = section.querySelectorAll('.reviews__swiper-slide')

        const reviewFunc = ()=> {
            if (window.matchMedia("(min-width:1024px)").matches) {
                if (itemsDesktop.length > 0) {
                    if (reviewsTriggerDesktop) {
                        reviewsTriggerDesktop.kill();
                    }

                    const chunkedArrays = chunkArray(itemsDesktop, 5);

                    chunkedArrays?.forEach(array=> {
                        reviewsTriggerDesktop = ScrollTrigger.create({
                            trigger: array[0],
                            start: 'top 85%',
                            end: 'bottom 10%',
                            onEnter: () => {
                                array?.forEach((item,index)=> {
                                    setTimeout(()=> {
                                        item.classList.add('play');
                                    },100*index)
                                })
                            },
                            onLeaveBack: () => {
                                array?.forEach((item,index)=> {
                                    setTimeout(()=> {
                                        item.classList.remove('play');
                                    },100*index)
                                })
                            },
                        });
                    })
                }
            } else {
                if (itemsMobile.length > 0) {
                    if (reviewsTriggerMobile) {
                        reviewsTriggerMobile.kill();
                    }
                    reviewsTriggerMobile = ScrollTrigger.create({
                        trigger: '.reviews__swiper',
                        start: 'top 85%',
                        end: 'bottom 10%',
                        onEnter: () => {
                            itemsMobile?.forEach((item,index)=> {
                                setTimeout(()=> {
                                    item.classList.add('play');
                                },100*index)
                            })
                        },
                        onLeaveBack: () => {
                            itemsMobile?.forEach((item,index)=> {
                                setTimeout(()=> {
                                    item.classList.remove('play');
                                },100*index)
                            })
                        },
                    });
                }
            }
        }

        reviewFunc()

        window.addEventListener('resize',reviewFunc)

        function chunkArray(array, chunkSize) {
            const result = [];
            for (let i = 0; i < array.length; i += chunkSize) {
                const chunk = Array.prototype.slice.call(array, i, i + chunkSize);
                result.push(chunk);
            }
            return result;
        }

    })
}